<template>
	<div>
		<div class="app-aj wrap innerbox" v-if="casenum">
			<div class="appdc" style="padding-left: 15px;padding-bottom: 15px;">待处理案件:({{caselst.length}}) <span class="app-ba wrap-app">此处案件为大救星APP用户报案，请尽快处理</span></div>
			<div v-for="item in caselst" :key=item.id>
				<div class="clan box">
					<span>{{item.time}}</span>
					<p class="p">
						<span class="baoan" :title="'由用户 ' + item.reportUser + ' 报案'">由用户 <a class="mingc">{{item.reportUser}}</a> 报案</span>
						<span class="mjzjy">【{{item.incidentTypeStr}}】</span>
						<span>出险地:{{setTxt(item.address)||""}}</span>
					</p>
          <div>
              <router-link style="color: #00abfa" class="app_box" :to="{name:'appcase',params:{token:token,caseId:item.caseId},query: {typeId:item.typeId,caseId:item.caseId}}">去创立案件</router-link>
              <el-button type="text" @click="dialogVisible=true;closeId=item.caseId">关闭案件</el-button>
          </div>
				</div>

			</div>
		</div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>确认关闭？</span>
      <textarea placeholder="请输入关闭原因" v-model="closeTxt" class="closeTxt"></textarea>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button style="margin-right:10px" type="button" @click="dialogVisible = false;closeCase(closeId)">确 定</el-button>
      </span>
    </el-dialog>
	</div>
</template>

<script>
 import { closeCase } from '@/views/axios/api.js';
	import "isomorphic-fetch";
	import constants from '@/util/constants.js';
	import Promise from 'promise-polyfill';
	if(!window.Promise) {
		window.Promise = Promise;
	}
	export default {
		props: ["token", "typeId"],
		data() {
			return {
				casenum: 0,
				caselst: [],
        closeId:'',
        dialogVisible:false,
        closeTxt:''
			};
		},
		methods: {
       closeCase(){
        var data={
          token:this.token,
          caseId:this.closeId
        }
        closeCase(data)
        .then(res => {
          if(res.data.code == 0){
            this.$message.success('案件已关闭')
            this.$router.go(0)
            this.dialogFormVisible1=false
          }
        })
        .catch(err => {
          console.log(err);
        })
      },
			setTxt(str,status){
				if(constants.setTxt(str,status)){
					return constants.setTxt(str,status)
				}else{
					return str
				}
			},
			toadd(caseid) {
				this.$router.push({
					name: "appcase",
					params: {
						token: this.token,
						caseId: caseid
					},
					query: {
						typeId: this.$route.query.typeId,
						caseId: caseid
					}
				});
			}
		},
		mounted() {
			let that = this;
			fetch(constants.domain + "rescue/case/case_count", {
					method: "POST",
					body: `token=${this.token}&status=90`,
					mode: "cors",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded"
					}
				})
				.then(function(res) {
					return res.json();
				})
				.then(function(data) {
					if(data.code == 0) {
						that.casenum = data.obj;
					}
				});
			fetch(constants.domain + "rescue/case/list_case", {
					method: "POST",
					body: `token=${this.token}&status=90`,
					mode: "cors",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded"
					}
				})
				.then(function(res) {
					return res.json();
				})
				.then(function(data) {
					if(data.code == 0) {
						if(data.code == 0 && data.obj) {
							for(var i = 0; i < data.obj.length; i++) {
//								if(i == 1) break;
								var w = data.obj[i];
								var o = {};
								o.caseId = w.obj.id;
								o.time = constants.time(w.obj.reportTs);
								o.reportUser = w.obj.reportUser;
								if(w.generalLocation && w.generalLocation.addr)
									o.address = w.generalLocation.addr;
								o.incidentTypeStr = w.incidentTypeStr;
								o.typeId = w.obj.incidentType;
								that.caselst.push(o);
							}
						}
					}
				});
		}
	};
</script>

<style scoped>
	.wrap {
		text-align: start;
		color: #333;
	}
	
	.app-aj {
		border: 1px solid #ffba00;
		box-sizing: border-box;
		font-size: 15px;
		border-radius: 3px;
		padding: 15px;
		max-height: 200px;
		overflow-y: auto;
	}
	
	.app-aj div {
		padding-bottom: 0;
		padding-left: 0;
		/* margin-bottom: 10px; */
	}
	
	.appdc {
		font-size: 16px;
		font-weight: 500;
	}
	
	.clan span {
		padding: 0px 5px;
	}
	
	.wrap-app {
		font-size: 15px;
		margin-left: 20px;
		color: #df1717;
	}
	
	.app_box {
		margin-left: 20px;
		text-decoration: none;
	}
	
	.box {
		display: flex;
		/* justify-content:space-between */
	}
	
	.box span:first-child {
		width: 190px;
	}
	
	.p {
		width: 800px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.box span.baoan{display: inline-block;width: 210px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;}
	.box span.mjzjy{display: inline-block;width: 140px;}
</style>


// WEBPACK FOOTER //
// src/components/cmd_center/addcase.vue